import { apiClient } from "./client"

export const usersApi = {
  getAll() {
    return apiClient.get("/users")
  },

  create(data) {
    return apiClient.post("/users", data)
  },

  update(userId, data) {
    return apiClient.patch(`/users/${userId}`, data)
  },

  delete(userId) {
    return apiClient.delete(`/users/${userId}`)
  },

  resetPassword(userId, newPassword) {
    return apiClient.post(`/users/${userId}/reset-password`, { newPassword })
  },

  getUserSites(userId) {
    return apiClient.get(`/users/${userId}/sites`)
  },

  grantSiteAccess(userId, siteId, role) {
    return apiClient.post(`/users/${userId}/sites/${siteId}`, { role })
  },

  revokeSiteAccess(userId, siteId) {
    return apiClient.delete(`/users/${userId}/sites/${siteId}`)
  },

  updateSiteRole(userId, siteId, role) {
    return apiClient.patch(`/users/${userId}/sites/${siteId}`, { role })
  },
}
